import { onElements } from './dom.js'
import { formatHms } from './time.js'

/**
 * Counts up the time since the game session started
 * (itword/templates/itword/components/_input_guess.html).
 *
 * The start is anchored to the elapsed seconds the server renders, measured
 * with the monotonic performance clock, so a device clock that's off (or
 * changes mid-game) doesn't skew the time shown. The interval only runs while
 * a timer is on the page.
 */
let interval = null

// The earliest start any timer has given, in performance.now() milliseconds.
// Each guess swaps in a timer whose elapsed seconds are behind by the
// request's latency, so keeping the earliest start stops it ticking back.
let startedAt = Infinity

const tick = () => {
    const timers = document.querySelectorAll('[data-game-timer-elapsed]')
    if (!timers.length) {
        clearInterval(interval)
        interval = null
        return
    }

    const elapsed = (performance.now() - startedAt) / 1000
    const label = formatHms(Math.max(0, Math.floor(elapsed)))
    timers.forEach((time) => {
        time.textContent = label
    })
}

onElements('[data-game-timer-elapsed]', (time) => {
    const elapsed = Number(time.dataset.gameTimerElapsed) * 1000
    startedAt = Math.min(startedAt, performance.now() - elapsed)
    tick()
    interval ??= setInterval(tick, 1000)
})
